export const Organisation = 'Organisation/';
export const SearchOrganisation = Organisation + "Search";
export const UserAccess = Organisation + 'UserAccess/';
export const SearchLinkedOrganisationAccessById = Organisation +'SearchLinkedOrganisationUserAccess';
export const OrganisationLinkedScorecards = Organisation + 'OrganisationLinkedScorecards/';
export const OrganisationsWithPayroll = Organisation + 'OrganisationsWithPayroll';
